<template>
  <div>
    <v-text-field
      v-validate="validator"
      outlined
      :value="value"
      label="Bairro"
      :disabled="disabled"
      :class="[(errors.first(field) || error) && 'block']"
      data-vv-validate-on="change|input"
      :error-messages="errors.first(field)"
      :name="field"
      v-bind="config"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  props: {
    value: String,
    field: String,
    config: Object,
    validator: Object,
    disabled: Boolean
  },
  data: () => ({
    error: null
  })
}
</script>

<style></style>
